import { config } from "../config";
import axios from "axios";

import { qrCode } from "../../../helpers/vorgange";

function createManualEntry(data, requestId, createNewRequest = false) {
  let url = `${config.apiUrl}/vorgangs/manual-request`;
  let method = "post";

  if (requestId && !createNewRequest) {
    url = `${config.apiUrl}/vorgangs/${requestId}/vorgang-attributes?fullResponse=true`;
    method = "patch";
  }

  return axios({
    method: method,
    url: url,
    data: data,
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error.response;
    });
}

function vollmachtTabValidation(requestId) {
  const url = `${config.apiUrl}/qes/${requestId}/vollmacht`;
  return axios({
    method: "get",
    url: url,
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

function getQRCode(requestId, QRCodeStatus) {
  const url = `${config.apiUrl}/qes/${requestId}/qrcode${
    QRCodeStatus === qrCode.generateNewQRCode ? "/renewal" : ""
  }`;

  return axios({
    method: "post",
    url,
    data: {
      requestId,
    },
    responseType: "blob",
  });
}

function getVollmachtSigningStatus(requestId) {
  let url = `${config.apiUrl}/qes/${requestId}/status`;
  return axios({
    method: "get",
    url: url,
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

// Starts the QES process for the given provider (Verimi ident or Category 2).
function startQESProcess(requestId, payload) {
  const url = `${config.apiUrl}/qes/${requestId}`;
  return axios({
    method: "post",
    url: url,
    data: payload,
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error.response;
    });
}

function getQESSupportData(requestId, source) {
  let url = `${config.apiUrl}/qes/${source}/${requestId}/support-data`;
  return axios({
    method: "get",
    url: url,
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

function getVollmachtSignedDocuments(requestId, docName) {
  let url = `${config.apiUrl}/qes/${requestId}/signedDocument/${docName}`;
  return axios({
    method: "get",
    url: url,
    responseType: "blob",
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

function getZulassungsbescheinigungDocuments(requestId, docName) {
  let url = `${config.apiUrl}/vorgangs/${requestId}/${docName}`;
  return axios({
    method: "get",
    url: url,
    responseType: "blob",
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

/**
 * Delete QES Process Data
 *
 * @param {*} requestId
 * @returns
 */

function deleteQES(requestId) {
  const url = `${config.apiUrl}/qes/${requestId}`;
  return axios({
    method: "delete",
    url: url,
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

function getCountriesList() {
  const url = `${config.apiUrl}/tcs/countries`;
  return axios({
    method: "get",
    url: url,
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

async function getRechtsFormData() {
  const url = `${config.apiUrl}/vorgangs/templates/rechtsform-data`;
  try {
    const resp = await axios.get(url);
    return resp;
  } catch (error) {
    return error;
  }
}

async function getWirtschaftszweigData() {
  const url = `${config.apiUrl}/vorgangs/templates/schluesselBeruf-data`;

  try {
    const resp = await axios({
      method: "get",
      url: url,
    });
    return resp;
  } catch (error) {
    return error;
  }
}

function getSteuerbefreiungData() {
  const url = `${config.apiUrl}/vorgangs/templates/steuerbefreiung-data`;
  return axios({
    method: "get",
    url: url,
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

function downloadWirtschaftsPDF() {
  const url = `${config.apiUrl}/vorgangs/templates/schluesselBeruf`;
  return axios({
    method: "get",
    url: url,
    responseType: "blob",
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

async function getBankDetailsByIban(iban, requestOptions) {
  const url = `${config.apiUrl}/vorgangs/iban-details/${iban}`;
  try {
    const resp = await axios({
      method: "get",
      url: url,
      ...requestOptions,
    });
    return resp;
  } catch (error) {
    return error;
  }
}

export const manualRequestFormService = {
  createManualEntry,
  vollmachtTabValidation,
  getQRCode,
  getVollmachtSigningStatus,
  startQESProcess,
  getQESSupportData,
  getVollmachtSignedDocuments,
  getZulassungsbescheinigungDocuments,
  deleteQES,
  getCountriesList,
  downloadWirtschaftsPDF,
  getRechtsFormData,
  getWirtschaftszweigData,
  getSteuerbefreiungData,
  getBankDetailsByIban,
};
